/**
 * Load Swiper after first paint. Mobile waits longer to protect Speed Index.
 * whenSwiperReady(callback)
 * whenSwiperReady(callback, { mobileDelay: 3500, desktopDelay: 800 })
 */
(function (window, document) {
  var loading = null;
  var CSS_HREF = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
  var JS_HREF = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
  var queue = window.__swiperQueue || [];

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
  }

  function loadAsset() {
    if (window.Swiper) return Promise.resolve();
    if (loading) return loading;

    loading = new Promise(function (resolve, reject) {
      if (!document.querySelector('link[data-swiper-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = CSS_HREF;
        link.setAttribute('data-swiper-css', 'true');
        document.head.appendChild(link);
      }

      var script = document.createElement('script');
      script.src = JS_HREF;
      script.async = true;
      script.onload = function () { resolve(); };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return loading;
  }

  function schedule(fn, options) {
    options = options || {};
    var mobileDelay = options.mobileDelay != null ? options.mobileDelay : 3000;
    var desktopDelay = options.desktopDelay != null ? options.desktopDelay : 500;
    var delay = isMobile() ? mobileDelay : desktopDelay;

    var run = function () {
      setTimeout(fn, delay);
    };

    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  function runCallback(callback, options) {
    if (!document.querySelector('.swiper')) return;
    schedule(function () {
      loadAsset().then(function () {
        if (typeof callback === 'function' && window.Swiper) callback();
      });
    }, options);
  }

  window.whenSwiperReady = function (callback, options) {
    runCallback(callback, options);
  };

  while (queue.length) {
    var item = queue.shift();
    if (typeof item === 'function') runCallback(item);
    else if (item && typeof item.cb === 'function') runCallback(item.cb, item.options);
  }
})(window, document);
